import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-base/80 backdrop-blur-md border-b border-border py-4' : 'bg-transparent py-6'}`} data-id="element-178">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-179">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-180">
          <span className="font-serif text-xl font-medium tracking-tight" data-id="element-181">
            Alex Circei
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8" data-id="element-182">
          {['Services', 'Work', 'About', 'Insights'].map(item => <button key={item} onClick={() => scrollTo(item.toLowerCase())} className="text-sm text-secondary hover:text-primary transition-colors" data-id="element-183">
              {item}
            </button>)}
        </nav>

        <div className="flex items-center gap-4" data-id="element-184">
          <Button size="sm" onClick={() => window.open('https://calendly.com/alexcircei/advising', '_blank')} data-id="element-185">
            Book a call
          </Button>
        </div>
      </div>
    </header>;
}